import { render, staticRenderFns } from "./BlankView.vue?vue&type=template&id=2812dbbd&scoped=true"
import script from "./BlankView.vue?vue&type=script&lang=js"
export * from "./BlankView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2812dbbd",
  null
  
)

export default component.exports